import {IS_PADDLE_IN_PRODUCTION} from "@/common/utils";

export const PADDLE_ENV = IS_PADDLE_IN_PRODUCTION ? 'production' : 'sandbox';

const PADDLE_KEY = IS_PADDLE_IN_PRODUCTION ? 'PROD' : 'TEST';

const PADDLE_CLIENT_TOKEN = IS_PADDLE_IN_PRODUCTION ?
    process.env.NEXT_PUBLIC_PADDLE_PROD_CLIENT_TOKEN :
    process.env.NEXT_PUBLIC_PADDLE_TEST_CLIENT_TOKEN;

export function paddleClientToken() {
    const envKey = `NEXT_PUBLIC_PADDLE_${PADDLE_KEY}_CLIENT_TOKEN`;
    const result = PADDLE_CLIENT_TOKEN;
    if (result == null) {
        throw new Error(`[${PADDLE_KEY}] Paddle client token missing in ${envKey}`);
    }
    return result;
}

export function paddleApiKey() {
    const envKey = `PADDLE_${PADDLE_KEY}_API_KEY`;
    const result = process.env[envKey];
    if (result == null) {
        throw new Error(`[${PADDLE_KEY}] Paddle API key missing in ${envKey}`);
    }
    return result;
}

export function paddleWebhookSecret() {
    const envKey = `PADDLE_${PADDLE_KEY}_NOTIFICATION_WEBHOOK_SECRET`;
    const result = process.env[envKey];
    if (result == null) {
        throw new Error(`[${PADDLE_KEY}] Paddle webhook secret missing in ${envKey}`);
    }
    return result;
}
